import React from "react";
import { SupChevronLeft, SupChevronRight } from "@repo/core-ui";
import { twMerge } from "tailwind-merge";
import { type CustomArrowProps } from "react-slick";

interface SliderButtonProps extends CustomArrowProps {
  direction: "prev" | "next";
}

export function SliderButton({ direction, className, onClick }: SliderButtonProps) {
  return (
    <button
      className={twMerge(
        "absolute bottom-0 top-0 hidden h-full w-8 items-center justify-center rounded-lg border-0.5 border-primary-200 bg-transparent text-neutral-800 transition-colors duration-300 hover:border-primary-500 hover:bg-primary-200 lg:flex",
        direction === "prev" && "-left-10",
        direction === "next" && "-right-10",
        className
      )}
      onClick={onClick}
    >
      {direction === "prev" ? <SupChevronLeft height={32} width={32} /> : <SupChevronRight height={32} width={32} />}
    </button>
  );
}
